module.exports = __webpack_public_path__ + "media/scale.8ba285ff.webm";